import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'
import { doGetSession, doLogout } from '../../utilities'

function AdminNavbar({ user_type, user_session }) {
    const router = useRouter()
    const [user, setUser] = React.useState(null)
    const [isLoggedIn, setIsLoggedIn] = React.useState(false)
    const [title, setTitle] = React.useState('EPT Management Console')
    const [homeUrl, setHomeUrl] = React.useState('/')
    const [activeScopeCode, setActiveScopeCode] = React.useState(null)
    const [activeScope, setActiveScope] = React.useState(null)

    React.useEffect(() => {
        // doGetSession().then(session => {
            if (user_session) {
                setUser(user_session.user)
                setIsLoggedIn(true)
                if (user_type && user_type == 'scope_manager') {
                    if (user_session?.user?.scopes && user_session?.user?.scopes?.length > 0) {
                        let scp = user_session?.user?.scopes[0]
                        if (scp?.uuid) {
                            setActiveScope(scp)
                            setActiveScopeCode(scp?.uuid)
                            setHomeUrl(`/admin/scopes/${scp?.uuid}`)
                            setTitle(scp?.name)
                        }
                    }
                }else {
                    setHomeUrl(user_session?.user?.type == 'admin' ? '/admin' : '/user')
                }

            }
        // })
        
        if(typeof window !== 'undefined') {
            const headerMenu = document.getElementById('headerMenu')
            // if site is staging/development, replace class(bg-violet-dark) with bg-amber-700
            if (headerMenu && (window.location.hostname.includes('-pilot') || window.location.hostname.includes('-training') || window.location.hostname.includes('localhost'))) {
                headerMenu.classList.remove('bg-violet-dark')
                headerMenu.classList.add('bg-amber-700')
            }
        }
    }, [])
    return (
        <>
            {(window.location.hostname.includes('-pilot') || window.location.hostname.includes('-training')  || window.location.hostname.includes('localhost')) && <div style={{padding: '4px', textAlign: 'center', zIndex: 9999, position: 'fixed', backgroundColor: 'white', width: '100vw'}}>
                <small>This is a training instance of the ePT platform for testing and training purposes only. For the live site, go to <Link href={'https://ept.nphl.go.ke'} target='_blank'>https://ept.nphl.go.ke</Link></small>
            </div>}
            <header id="headerMenu" style={{top: (window.location.hostname.includes('-pilot') || window.location.hostname.includes('-training')  || window.location.hostname.includes('localhost')) ? '25px' : '0px'}} className="navbar navbar-dark sticky-top bg-darkz bg-violet-dark flex-md-nowrap p-0 shadow w-100">
                <div className='w-100 d-flex align-items-center justify-content-between'>
                    <Link href="/" className="navbar-brand col-md-3 col-lg-2 me-0 py-3 px-3 bg-transparent border-none">{title}</Link>
                    <div className="px-3">
                        <ul className="navbar-nav me-auto mb-lg-0">
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="adminAccDropDwn" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {/* <span>{user ? user.name : 'Account'}</span> */}
                                    <span className='ml-1'>
                                        <i className='fa fa-user'></i> <span className='d-none d-md-inline-flex'>Account</span>
                                    </span>
                                </a>
                                <ul className="dropdown-menu" aria-labelledby="adminAccDropDwn" style={{ position: 'absolute', right: 2, left: 'auto', marginTop: 5 }}>
                                    <li><p className='m-0 w-100 text-slate-500 text-small text-center'>{user?.name}</p></li>
                                    <li className='dropdown-divider'></li>
                                    <li><Link href="/admin/settings/account" className="dropdown-item">Profile</Link></li>
                                    {/* <li><Link legacyBehavior href="/admin/settings"><a className="dropdown-item">Settings</a></Link></li> */}
                                    {/* <li><hr className="dropdown-divider" /></li> */}
                                    <li><button className="dropdown-item" onClick={ev => { doLogout(router) }}>Sign out</button></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <button className="navbar-toggler position-absolute d-md-none collapsed" style={{ marginRight: '2.1em', marginTop: '0.5rem' }} type="button" data-bs-toggle="collapse" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
            </header>
        </>
    );
}

export default AdminNavbar